import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
    return (
        <footer className={styles['page-footer']}>
            <p>© 2026 Hari Om Electricals. All Rights Reserved. | Developed by Weborative IT Consultancy</p>
        </footer>
    );
};

export default Footer;
